// extracted by mini-css-extract-plugin
export default {"container":"Review_container__YSRqB","item":"Review_item__8gQhI","row":"Review_row__YoJv7","reviewItem":"Review_reviewItem__NIZyG","reviews":"Review_reviews__RISka"};